// `extract.typography`: a brand's Google font classified as live classifies it (spec
// G15b-brand-typography). A brand's save starts it on the server; live lists no such job, and a
// Studio draft never holds one.
import { ExtractTypographyQuote, ExtractTypographyRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"extract.typography"> = {
  type: "extract.typography",
  label: "Brand typography",
  source: "form",
  pair: "extract.typography",
  fields: () => ({}),
  request: ExtractTypographyRequest,
  quote: ExtractTypographyQuote,
};
